export default "__VITE_ASSET__DXlXj$Eo__"